// 神策统计相关
import sa from 'sa-sdk-javascript'
import _ from 'lodash'
// 区分本地环境和线上环境
const projectMode = process.env.VUE_APP_ENV_MICRO === 'production' ? 'default' : 'default'

export default class {
  _channelFrom = '0'
  constructor (channelFrom) {
    this._channelFrom = channelFrom || '0'
    this._init(this._channelFrom)
  }

  _init (channelFrom) {
    // 神策数据初始化
    sa.init({
      name: 'sa',
      web_url: 'https://sc.hzmantu.com:8107/?project=' + projectMode,
      server_url: 'https://sc.hzmantu.com:8106/sa?project=' + projectMode,
      show_log: false,
      heatmap: {
        // 是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
        clickmap: 'default',
        // 是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
        scroll_notice_map: 'default'
      }
    })
    sa.quick('autoTrack', {
      brand: 'himo',
      channel_from: channelFrom
    })
  }

  login (userid) {
    sa.login(userid)
  }

  autoTrackSinglePage () {
    sa.quick('autoTrackSinglePage')
  }

  track (name, data, option = {}) {
    const scopeData = _.assign({}, data)
    if (!option.noChannel) scopeData.channel_from = this._channelFrom
    if (!option.noPlatform) scopeData.platform_id = 1
    sa.track(name, scopeData)
  }

  get channelFrom () {
    return this._channelFrom
  }
}
